module.exports = __webpack_public_path__ + "img/PinEnd.e9b0e267.svg";